import React, {useMemo} from 'react';
import objectPath from 'object-path';
import {useHtmlClassService} from '../_core/MetronicLayout';
import {Header} from './header/Header';
import {Footer} from './footer/Footer';
import {LayoutInit} from './LayoutInit';
import {SubHeader} from './subheader/SubHeader';
import {useSubheader} from '../_core/MetronicSubheader';
import Navigation from '../../../app/modules/_common/components/Navigation/Navigation';

export function Layout({children}) {
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, 'self.layout'),
      asideDisplay: objectPath.get(uiService.config, 'aside.self.display'),
      subheaderDisplay: objectPath.get(uiService.config, 'subheader.display'),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        'header.self.fixed.desktop'
      ),
      contentExtended: objectPath.get(uiService.config, 'content.extended')
    };
  }, [uiService]);

  const subheader = useSubheader();
  const classWithSubheader = (subheader.displaySubheader) ? '' : 'withoutSubheader';

  return layoutProps.selfLayout !== 'blank' ? (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page">
          <Navigation/>
          <div
            className={`d-flex flex-column flex-row-fluid wrapper pl-0 ${classWithSubheader}`}
            id="kt_wrapper"
          >
            <Header/>
            {subheader.displaySubheader && <SubHeader/>}
            <div
              id="kt_content"
              className={`content d-flex flex-column flex-column-fluid`}
            >
              {!layoutProps.contentExtended && (
                <div className="flex-column-fluid layout-container">
                  {children}
                </div>
              )}
              {layoutProps.contentExtended && {children}}
            </div>
            <Footer/>
          </div>
        </div>
      </div>
      <LayoutInit/>
    </>
  ) : (
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
